import commonApi from '@/api/api.common'
import i18n from '@/locales/index'
export default [
  {
    type: 'input',
    placeholder: i18n.t('Device.deviceCode'),
    filed: 'code',
    default: ''
  },
  {
    type: 'input',
    placeholder: i18n.t('Device.factoryArea'),
    filed: 'factoryArea',
    default: ''
  }
  // {
  //   type: 'select',
  //   placeholder: '设备状态',
  //   filed: 'state',
  //   default: '',
  //   query: commonApi.device_state_select
  // },
  // {
  //   type: 'select',
  //   placeholder: '在离线',
  //   filed: 'online',
  //   default: '',
  //   query: commonApi.device_online_select
  // }
]
